export const AddressStatusTypes = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  Inactive: 'Inactive'
}